import axios from 'axios';

const publicHttp = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

// Resolves to the API body on success, or { error, errors } (errors = field -> [messages]) on failure.
export const customerInfoSubmitRequest = async (data) => {
    return await publicHttp.post('customerInfo/submit', data)
        .then(res => res.data)
        .catch(err => ({
            error: err.response?.status === 429 ? 'Too Many Attempts.' : (err.response?.data?.message || err.message),
            errors: err.response?.data?.errors || {},
        }));
};
